<template>
<div class="invateManagerDialog" v-if="dialogVisible">
    <el-dialog title="邀请管理员" :visible.sync="dialogVisible" @close="cancel" width="300px">
        <div class="share">
            <div class="box">
                <img :src="imgBase64" alt="邀请链接" class="img">
                <div class="pr-code-text cursor tc-blue" @click="download(item.imgBase64, item.title)">下载二维码</div>
                <div class="btns">
                    <el-input v-model.trim="inviteurlurl" placeholder="" disabled></el-input>
                    <el-button type="primary" size="mini" v-clipboard:copy="inviteurlurl" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</el-button>
                </div>
            </div>
        </div>
    </el-dialog>
</div>
</template>

<script>
import {urlToQRCode, downloadImage} from 'common/js/tools'
export default {
    name: 'invateManagerDialog',
    data() {
        return {
            dialogVisible: false,
            inviteurlurl: '',
            imgBase64: ''
        }
    },
    mounted() {
    },
    methods: {
        openDialog(inviteurlurl) {
            this.dialogVisible = true
            this.imgBase64 = urlToQRCode(inviteurlurl)
            this.inviteurlurl = inviteurlurl
        },
        cancel() {
            this.dialogVisible = false
        },
        download(imgsrc, name) {
            downloadImage(imgsrc, name)
        },
        onCopy(e) {
            this.$message({
                message: '复制成功',
                type: 'success'
            })
        },
        onError(e) {
            alert('失败')
        },
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.invateManagerDialog {
    .share{
        @include flexBox(space-around);
        .box{
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .btns{
                display: flex;
                align-items: center;
                margin: 10px 0;
                .el-button{
                    margin:0;
                }
            }
            .img{
                width: 134px;
                height: 134px;
            }
        }
        .box+.box{
            margin-left: 20px;
        }
    }
}
</style>
